import { Link, useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));

  const links = [
    { name: "إرسال نص ترويجي", url: `${process.env.PUBLIC_URL}/send-offer` },
    { name: "إرسال تعميم ", url: `${process.env.PUBLIC_URL}/send-circular` },
    {
      name: "العملاء",
      url: `${process.env.PUBLIC_URL}/distributors`,
    },

    {
      name: "المناطق",
      url: `${process.env.PUBLIC_URL}/regions`,
    },
    {
      name: "الإقتراحات",
      url: `${process.env.PUBLIC_URL}/suggestions`,
    },
    {
      name: "الطلبات",
      url: `${process.env.PUBLIC_URL}/orders`,
    },
    {
      name: "المنتجات الغذائية ",
      url: `${process.env.PUBLIC_URL}/items`,
    },
    {
      name: "تسجيل مستخدم جديد",
      url: `${process.env.PUBLIC_URL}/create-user`,
    },
    {
      name: "المستخدمين",
      url: `${process.env.PUBLIC_URL}/users`,
    },
    {
      name: "الرئيسة",
      url: `${process.env.PUBLIC_URL}/`,
    },
  ];
  const logoutUser = () => {
    localStorage.removeItem("user");
    navigate(`${process.env.PUBLIC_URL}/login`);
  };
  return (
    <>
      <nav className="bg-blue-500 p-4 flex justify-between items-center">
        <div className="hidden lg:flex items-center space-x-4">
          <button className="text-white" onClick={logoutUser}>
            تسجيل الخروج
          </button>
          {user.privilege !== 1 ? (
            <Link to={`${process.env.PUBLIC_URL}/orders`} className="text-white p-4">
              <span>الطلبات</span>
            </Link>
          ) : (
            ""
          )}
        </div>

        <div className="flex items-center space-x-4 lg:hidden">
          <button
            id="menu-button"
            className="text-white"
            onClick={() => {
              document.getElementById("mobile-menu").classList.toggle("hidden");
            }}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </div>
        <div>
          <h3 className="text-white text-xl font-semibold">
            مرحبا {user.name !== "" ? "" : user.name}
          </h3>
        </div>
      </nav>
      <nav className="bg-blue-500  flex justify-center items-center">
        {user.privilege === 1 ? (
          <div className="hidden lg:flex items-center space-x-4">
            {links.map((el) => {
              return (
                <Link to={el.url} className="text-white p-4" key={el.name}>
                  <span> {el.name}</span>
                </Link>
              );
            })}
          </div>
        ) : (
          ""
        )}
      </nav>
      {/* <!-- Mobile Navigation Menu --> */}
      <div id="mobile-menu" className="bg-blue-500 p-4 text-white hidden">
        <button className="block mb-2">تسجيل الخروج</button>
        {user.privilege === 1 ? (
          links.map((el) => {
            return (
              <Link to={el.url} className="block mb-2" key={el.name}>
                <span> {el.name}</span>
              </Link>
            );
          })
        ) : (
          <Link to={`${process.env.PUBLIC_URL}/orders`} className="block mb-2 ">
            <span>الطلبات</span>
          </Link>
        )}
      </div>
    </>
  );
}

export default Navbar;
